const STRINGS = {
  previousButtonAriaLabel: "Previous",
  nextButtonAriaLabel: "Next"
};
export default STRINGS;